import React, { useState, useEffect } from 'react';
import './App.css';
import { translations } from './i18n/translations';
import { Header } from './components/Header';
import { HeroSection } from './components/HeroSection';
import { ServicesSection } from './components/ServicesSection';
import { ContactSection } from './components/ContactSection';
import { Footer } from './components/Footer';
import { Toaster } from './components/ui/sonner';

function App() {
  const [language, setLanguage] = useState('en');

  useEffect(() => {
    // Check if user has a preferred language stored
    const savedLang = localStorage.getItem('preferredLanguage');
    if (savedLang && translations[savedLang]) {
      setLanguage(savedLang);
    }
  }, []);

  const handleLanguageChange = (lang) => {
    setLanguage(lang);
    localStorage.setItem('preferredLanguage', lang);
  };

  const t = translations[language];

  return (
    <div className="App bg-slate-900 min-h-screen">
      <Header 
        t={t} 
        currentLang={language} 
        onLanguageChange={handleLanguageChange}
      />
      <HeroSection t={t} />
      <ServicesSection t={t} />
      <ContactSection t={t} />
      <Footer t={t} />
      <Toaster position="top-right" />
    </div>
  );
}

export default App;
